import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Outlet,
} from 'react-router-dom';
import PrivateRoute from './routes';
import { AuthProvider } from '../context/Auth/AuthContext';
import { TicketsContextProvider } from '../context/Tickets/TicketsContext';
import { WhatsAppsProvider } from '../context/WhatsApp/WhatsAppsContext';
import {
  ChatMoments,
  Connections,
  Contacts,
  Dashboard,
  FileLists,
  Login,
  Queues,
  QuickMessages,
  SettingsPage,
  Tags,
  TicketResponsiveContainer,
  Users,
  Companies,
  AllConnections,
  EsqueciSenha,
} from '../pages';
import LoggedInLayout from '../layout';
import { Bounce, ToastContainer } from 'react-toastify';

const LayoutWrapper = () => (
  <WhatsAppsProvider>
    <LoggedInLayout>
      <Outlet />
    </LoggedInLayout>
  </WhatsAppsProvider>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <RouterRoutes>
            {/* Rota pública */}
            <Route path='/login' element={<Login />} />
            <Route path='/forgot-password' element={<EsqueciSenha />} />

            {/* Rotas protegidas */}
            <Route element={<PrivateRoute />}>
              <Route element={<LayoutWrapper />}>
                <Route path='/' element={<Dashboard />} />
                <Route path='/moments' element={<ChatMoments />} />
                <Route path='/contacts' element={<Contacts />} />
                <Route path='/tags' element={<Tags />} />
                <Route path='/quick-messages' element={<QuickMessages />} />
                <Route path='/users' element={<Users />} />
                <Route path='/queues' element={<Queues />} />
                <Route path='/connections' element={<Connections />} />
                <Route path='/files' element={<FileLists />} />
                <Route path='/settings' element={<SettingsPage />} />
                <Route path='/companies' element={<Companies />} />
                <Route path='/allConnections' element={<AllConnections />} />
                <Route
                  path='/tickets/:ticketId?'
                  element={<TicketResponsiveContainer />}
                />
                {/* Adicione aqui todas as outras rotas privadas */}
              </Route>
            </Route>
          </RouterRoutes>
          <ToastContainer
            position='top-center'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='dark'
            transition={Bounce}
          />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
